import React from 'react';
import Lottie from 'react-lottie';
import animationData from '../svg/CancelAnimatedIcon.json';

function CancelIcon() {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    },
  };

  return (
    <div>
      <Lottie 
        options={defaultOptions}
        height={90}
        width={90}
      />
    </div>
  );
}

export default CancelIcon;